<!-- eslint-disable -->
<template lang="pug">
    .block-notification
        .block-notification__container
            svg-icon(name="lock", :aria-hidden="true" size="xx-large")
            .block-notification__text
                | {{ messageText }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            schoolsBlocked: Boolean,
            usersAccountBlocked: Boolean,
            userIsAdmin: Boolean,
        },
        computed: {
            messageText () {
                if (this.usersAccountBlocked && !this.schoolsBlocked) {
                    return this.$i18n.t('common.common_blockNotification_selfPayedUser');
                }
                if (this.schoolsBlocked && this.userIsAdmin) {
                    return this.$i18n.t('common.common_blockNotification_admin');
                }
                if (this.schoolsBlocked) {
                    return this.$i18n.t('common.common_blockNotification_users');
                }
                return "";
            }
        }
    }
</script>

<style lang="scss" scoped>
    .block-notification {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .block-notification__container {
        border: 2px solid $hsl_color_red-62;
        border-radius: 12px;
        padding: 30px;
        display: flex;
        align-items: center;
        .svg-icon {
            margin-right: 30px;
        }
        @media screen and (max-width: 767px) {
            flex-direction: column;
            .svg-icon {
                margin-right: 0;
                margin-bottom: 10px;
            }
        }
    }

    .block-notification__text {
        text-align: center;
        font-size: 20px;
        @media screen and (max-width: 400px) {
            font-size: 16px;
        }
    }
</style>
